export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/ed3e1222f5d7e466f1889a4510f1de5c.svg";